import BillsNotifyPreview from '@/components/client/bills/notify/BillsNotifyPreview.vue'

export default {
  name: 'BillsNotify',
  data () {
    return {
      filterValues: {
        reportSubCode: [],
        fromDatePeriod: null,
        toDatePeriod: null,
        bill_number: '',
        clientName: '',
        onlyMine: [],
        managers: [],
        type: [],
        lastNotificationBefore: null,
        remainingBalanceAtLeast: ''
      },
      currentReq: null,
      loading: false,
      items: []
    }
  },
  components: {
    BillsNotifyPreview
  },
  computed: {
    getTitle () {
      return this.$t('menu.bills.notify');
    },
    tableFilterConfig () {
      const filters = { };
      filters.reportSubCode = { type: 'checkbox', label: this.$t('client.filters.reportSubCode'), options: this.reportNameOptions };
      filters.fromDatePeriod = { type: 'date-period', label: this.$t('general.filters.date-period-from'), class: 'col-md-2' }
      filters.toDatePeriod = { type: 'date-period', label: this.$t('general.filters.date-period-to'), class: 'col-md-2' }
      filters.managers = { type: 'checkbox', label: this.$t('client.manager'), options: this.managerOptions, valueField: 'api_id' };
      filters.onlyMine = { type: 'checkbox', label: ' ', options: this.onlyMineOptions, class: 'col-md-2' };
      filters.bill_number = { type: 'text', label: this.$t('bill.number'), class: 'col-md-2' };
      filters.clientName = { type: 'text', label: this.$t('client.name'), class: 'col-md-2' };
      filters.type = { type: 'checkbox', label: this.$t('bill.type'), options: this.billTypeOptions, class: 'col-md-2' }
      filters.lastNotificationBefore = { type: 'date', label: this.$t('bill.lastNotificationBefore'), class: 'col-md-2' }
      filters.remainingBalanceAtLeast = { type: 'number', label: this.$t('bill.remainingBalanceAtLeast'), class: 'col-md-2', precision: 0 }
      return filters;
    },
    billTypeOptions () {
      return this.$store.getters.getConfigOptions('bill_types', this.$i18n.locale);
    },
    reportNameOptions () {
      return this.ZPFormatHelper.getReportNameOptions(false, false);
    },
    managerOptions () {
      return this.$store.getters.getConfigOptions('managers');
    },
    onlyMineOptions () {
      return [
        { code: 1, text: this.$t('client.onlyMine') }
      ];
    },
    tableHeaders () {
      const headers = [
        { key: 'name', label: this.$t('client.name'), type: 'routelink', routeTo: 'menu.client.edit', params: { clientApiId: 'api_id' }, filterKey: 'clientName', sortable: true },
        { key: 'balance', label: this.$t('client.balanceD365'), format: 'formatDecimal', precision: 2, sortable: true },
        { key: 'receiver_emails', label: this.$t('bill.receiver_emails'), type: 'slot', slotcode: 'receiver_emails' },
        { key: 'remainingBalance', label: this.$t('bill.remainingBalance'), format: 'formatDecimal', precision: 2, sortable: true, class: 'text-break', filterKey: 'remainingBalanceAtLeast' },
        { key: 'bills.length', label: this.$t('bill.count'), sortable: true },
        { key: 'min_due_date', label: this.$t('bill.due_date'), type: 'date', sortable: true },
        { key: 'last_notified_at', label: this.$t('client.lastNotifiedAt'), type: 'datetime', sortable: true, filterKey: 'lastNotificationBefore' },
        { key: 'checked', label: this.$t('menu.bills.notify-column'), type: 'slot', slotcode: 'checkbox' }
      ];
      return headers;
    },
    tableBillHeaders () {
      const headers = [
        { key: 'created_at', label: this.$t('bill.created'), type: 'datetime' },
        { key: 'bill_number', label: this.$t('bill.number'), filterKey: 'bill_number' },
        { key: 'type_id', label: this.$t('bill.type'), format: 'formatFromConfig', configKey: 'bill_types', configParam: 'name', filterKey: 'type' },
        { key: 'due_date', label: this.$t('bill.due_date'), type: 'date', filterKey: 'due_date' },
        { key: 'date_period_id', label: this.$t('bill.date_period_id'), format: 'formatDatePeriod' },
        { key: 'client_report.summary', label: '', format: 'formatReportModificationIcons', class: 'text-right' },
        {
          key: 'client_report.report_config_id',
          label: this.$t('bill.report'),
          type: 'slot',
          slotcode: 'reportlink'
        },
        { key: 'price_total', label: this.$t('general.currency'), format: 'formatDecimal', precision: 2 },
        { key: 'remainingBalance', label: this.$t('bill.remainingBalance'), format: 'formatDecimal', precision: 2, filterKey: 'isPaid' },
        { key: 'notifiedAt', label: this.$t('bill.notifiedAt'), type: 'datetime' },
        { key: 'notifyCount', label: this.$t('bill.notifyCount') }
      ];
      return headers;
    }
  },
  methods: {
    show (activeFilters) {
      Object.keys(activeFilters).forEach(key => {
        if (Object.prototype.hasOwnProperty.call(this.filterValues, key)) {
          this.filterValues[key] = activeFilters[key];
        }
      });
      this.getTableData();
      this.$refs['modal-window'].show();
    },
    close () {
      this.$refs['modal-window'].hide();
    },
    getTableData () {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      this.loading = true;
      this.$forceUpdate();
      let filterValues = this.BasicHelper.cloneObject(this.filterValues);
      if (this.$refs.billstable) {
        filterValues = this.$refs.billstable.getFilterValues();
        this.BasicHelper.updateFilterValues(this.$route.name, filterValues);
      }
      const self = this;
      this.currentReq = this.ApiRequest.request('client-bill/unpaid/grouped', this.ApiRequest.REQUEST_POST, filterValues, function (response) {
        if (response.data) {
          self.items = response.data;
          self.loading = false;
        }
      })
    },
    checkallItems (val) {
      if (this.items) {
        Object.keys(this.items).forEach(key => {
          if (!this.items[key].isOverpaid) {
            this.items[key].checked = val;
          }
        });
      }
      this.$forceUpdate();
    },
    openNotifyPreview () {
      const clientIds = this.items.filter(el => el.checked).map(el => el.id);
      if (clientIds.length > 0) {
        this.$refs.notifyPreview.show(clientIds);
      }
    },
    onNotificationsSent () {
      this.getTableData();
    },
    getReportUrlParams (item) {
      const res = {
        datePeriodCode: item.client_report.date_period_id,
        reportCode: this.BasicHelper.getConfigValue('report_configs', 'id', item.client_report.report_config_id, 'code', false),
        clientApiId: null
      }
      const client = this.items.find(el => el.id == item.client_id);
      if (client) {
        res.clientApiId = client.api_id;
      }
      return res;
    }
  }
}
